var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subtitle-1 grey--text text--darken-3 font-weight-medium"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }